import { Component, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

export const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-background" role="status" aria-live="polite">
    <div className="h-10 w-10 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
    <span className="sr-only">Cargando…</span>
  </div>
);

interface State { error: Error | null }

class Boundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error) { console.error("Route error:", error); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-6 text-center">
        <h1 className="text-2xl font-bold text-foreground">No pudimos cargar esta página</h1>
        <p className="text-muted-foreground max-w-md">Puede deberse a una actualización reciente del sitio o a la conexión.</p>
        <div className="flex gap-3">
          <button onClick={() => window.location.reload()} className="rounded-full bg-primary px-5 py-2 text-primary-foreground">Reintentar</button>
          <a href="/" className="rounded-full border border-border px-5 py-2 text-foreground">Ir al inicio</a>
        </div>
      </div>
    );
  }
}

/** Resets automatically when the route changes. */
export const RouteErrorBoundary = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  return <Boundary key={pathname}>{children}</Boundary>;
};
